import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiStripepaymentgatewayPublishableKeyQueryResponse,
  GetApiStripepaymentgatewayPublishableKey401,
  GetApiStripepaymentgatewayPublishableKey403,
} from "../../../types/GetApiStripepaymentgatewayPublishableKey";

export function getGetApiStripepaymentgatewayPublishableKeyUrl() {
  return `/api/StripePaymentGateway/publishable-key` as const;
}

/**
 * {@link /api/StripePaymentGateway/publishable-key}
 */
export async function getApiStripepaymentgatewayPublishableKey(
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiStripepaymentgatewayPublishableKeyQueryResponse,
    ResponseErrorConfig<
      | GetApiStripepaymentgatewayPublishableKey401
      | GetApiStripepaymentgatewayPublishableKey403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiStripepaymentgatewayPublishableKeyUrl().toString(),
    ...requestConfig,
  });
  return res;
}
